const styles = {
  button: {
    minWidth: '140px'
  }
}

export default styles
